import React, { Component } from 'react';
//styles
import './header.scss';

class Header extends Component {
  state = {
    transform: -100,
    shareUrl: "https://z.ynet.co.il/mshort/content/2018/FlagCarriers/",
    showSelectTransform: false,
    isDecadeMenuVisible: false,
    decadeIdTransform: 45,
    isShowFixedMenu: false,
    isMenuShow: false
  }
  negishut() {
    document.getElementById('INDmenu-btn').click();
  }
  shareFacebook = () => {
    window.open("https://www.facebook.com/share.php?u=" + this.state.shareUrl, '_blank', "width=500,height=300");
    this.props.sendGA("Share_Facebook", this.state.shareUrl);
  }
  shareTwitter = () => {
    let title = "נושאי הדגל - ynet";
    let description = 'האנשים שמאחורי המאבקים הבולטים של קהילת הלהט"ב בישראל חוזרים לרגעי הייאוש והשפל, מספרים על פריצות הדרך החשובות - ומקווים לעתיד ורוד יותר. פרויקט מיוחד'
    let url = 'https://twitter.com/intent/tweet?text=' + title + " " + description + "%0A" + this.state.shareUrl;
    window.open(url, '_blank', "width=500,height=300");
    this.props.sendGA("Share_Twitter", this.state.shareUrl);
  }
  shareWhatsapp = () => {
    let url = `whatsapp://send?text=${this.state.shareUrl}`;
    window.open(url, '_blank', "width=500,height=300");
    this.props.sendGA("Share_Whatsapp", url);
  }

  sendMail=()=>{
    this.props.sendGA("Write_Mail", '');
  }
  showMenu = () => {
    this.setState(prevState => ({
      isMenuShow: !prevState.isMenuShow
    }));
  }

  componentDidMount() {
    window.addEventListener('scroll', () => this.handleScroll(this.state.isDecadeMenuVisible, this.showDecadeMenu));
  }

  handleScroll() {
    if (window.scrollY > 0) {
      this.showFixedMenu(true);
    }
    else {
      this.showFixedMenu(false)
    }
  } 
  
  showFixedMenu(show) {
    this.setState({
      isShowFixedMenu: show
    });
  }
  render() {
    return (
      <div className={this.props.isArticle ? "article-menu" : ""}>
        <div className={this.state.isShowFixedMenu || this.props.isArticle ? "share-container fixed" : "share-container"}>
          <div className={this.state.isMenuShow ? "menu show" : "menu"}>

            <div className={this.state.isMenuShow ? "mobile-menu-icon show" : "mobile-menu-icon"} onClick={this.showMenu}>
              <div className="first"></div>
              <div className="second"></div>
              <div className="third"></div>
            </div>
            <div className="main-img-header" onClick={() => window.open('https://ynet.co.il', '_blank') }></div>
            <div className="main-img-title">נושאי הדגל</div>
            <div className="menu-icon"></div>
            <ul className="menu-list" id="menu" >
              {
                this.props.isArticle ?
                <a href="./#/"><li className="go-back"><span>חזרה לעמוד הראשי<div className="arrow"></div></span></li></a>
                  : ""
              }

              <a href="https://redmail.ynet.co.il" onClick={this.sendMail} target="_blank">
                <li className="write-us"><span>כתבו לנו</span></li>
              </a>
              <li className="twitter" onClick={this.shareTwitter}></li>
              <li className="whatsapp" onClick={this.shareWhatsapp}></li>
              <li className="facebook" onClick={this.shareFacebook}></li>
              <li className="accessibility" onClick={this.negishut}></li>
            </ul>
            <a className={this.props.isArticle?"return-home":"return-home hide"} href="./#/" target="_self">{'>'}</a>
          </div>
        </div>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Components/Header/Header.js